import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@eatclubapp/ec-component-library';
import { Input } from '@mui/material';
import useStyles from './CurrencyInputStyles';

const validateAmount = (input, allowDecimals = false) => {
  if (allowDecimals) {
    return /^[0-9\b]+\.?[0-9]?[0-9]?$/.test(input);
  }
  return /^[0-9\b]+$/.test(input);
};

const CurrencyInput = ({
  value,
  onChange,
  placeholder = 'E.g. 100',
  currencySymbol = '$',
  allowDecimals = false,
  error = false,
  className,
  ...otherProps
}) => {
  const classes = useStyles();

  const handleChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue === '' || validateAmount(inputValue, allowDecimals)) {
      onChange && onChange(e);
    }
  };

  return (
    <Box
      className={`${classes.currencyInputContainer} ${error ? classes.currencyInputError : ''} ${className || ''}`}
    >
      <Box
        className={`${classes.currencySymbolBox} ${error ? classes.currencySymbolBoxError : ''}`}
      >
        {currencySymbol}
      </Box>
      <Input
        className={classes.currencyInput}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disableUnderline
        {...otherProps}
      />
    </Box>
  );
};

CurrencyInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  currencySymbol: PropTypes.string,
  allowDecimals: PropTypes.bool,
  error: PropTypes.bool,
  className: PropTypes.string,
};

export default CurrencyInput;
